import { render, staticRenderFns } from "./WeeksOfMonthComponent.vue?vue&type=template&id=1378bdd2&scoped=true&"
import script from "./WeeksOfMonthComponent.vue?vue&type=script&lang=js&"
export * from "./WeeksOfMonthComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378bdd2",
  null
  
)

export default component.exports